<template>
    <div class="cell-render-percent">
        {{ params.value|formatNumber }}%
    </div>
</template>

<script>
export default {}
</script>
